function Hero() {
  return (
    <div className="flex items-top justify-center mt-4 lg:mt-0 bg-contain bg-heroMobile md:bg-hero tablet:bg-center md:bg-center bg-no-repeat h-60 md:h-96"></div>
  );
}

export default Hero;
